<template>
  <div
    class="input-group input-group-outline m-0 d-flex flex-column position-relative"
  >
    <label class="input-label justify-content-start text-start w-100">
      <span class="text-xs text-uppercase text-body font-weight-bolder">
        {{ label }}
      </span>
      <div class="d-flex align-items-center position-relative">
        <select
          :value="modelValue"
          class="form-control default-bordered-input w-100"
          :disabled="disabled"
          @change="handleSelect($event.target.value)"
        >
          <option v-if="placeholder" value="" disabled selected>
            {{ placeholder }}
          </option>
          <option
            v-for="(option, index) in options"
            :key="index"
            :value="option[itemValue]"
          >
            {{ option[itemText] }}
          </option>
        </select>
      </div>
    </label>
  </div>
</template>

<script>
export default {
  name: "DefaultSelect",
  props: {
    label: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: "",
    },
    modelValue: {
      type: [String, Number],
      required: true,
    },
    options: {
      type: Array,
      required: true,
      default: () => [],
    },
    itemText: {
      type: String,
      default: "label",
    },
    itemValue: {
      type: String,
      default: "value",
    },
  },
  methods: {
    handleSelect(value) {
      this.$emit("update:modelValue", value);
    },
  },
};
</script>

<style scoped lang="scss">
.default-bordered-input {
  border: 1px solid #d2d6da !important;
  border-radius: 0.375rem !important;
  padding: 0.5rem 0.75rem !important;
  background-color: transparent !important;
  width: 100%;
}

.default-bordered-input:focus {
  border-color: #661cb0 !important;
  outline: 0 !important;
  box-shadow: 0 0 0 2px rgba(102, 28, 176, 0.2) !important;
}
</style>
